import React, { forwardRef, useState, useEffect } from 'react';
import OrganisationType from '../OrganisationType';
import OrganisationYINC from '../OrganisationYINC';
import OrganisationAbnAcn from '../OrganisationAbnAcn';
import styles from './OrganisationWrapped.module.scss';
import { Form } from '@snsw/react-component-library';
import OrganisationOther from '../OrganisationOther';
import FormError from '../FormError/FormError';

const OrganisationWrapped = (props, ref) => {
  const REACT_APP_DEFAULT_BASE_URL = 'http://localhost:4001';
  const REACT_APP_GET_ABN_URL = '/abnAcnApi/Lookup/GetAbrDetailsByAbn';
  const REACT_APP_GET_ACN_URL = '/abnAcnApi/Lookup/GetAbrDetailsByAcn';

  const registrationRef = React.createRef();
  const YINCRef = React.createRef();
  const ABNRef = React.createRef();
  const ACNRef = React.createRef();
  const [typeError, setTypeError] = useState(false);

  const setAbn = props.setAbn ? props.setAbn : () => {};
  const setAcn = props.setAcn ? props.setAcn : () => {};

  useEffect(() => {
    setTypeError(false);
  }, [props.regoType]);

  if (ref) {
    ref.current = {
      validate: () => {
        if (!props.regoType) {
          setTypeError(true);
          return false;
        } else if (props.regoType === 'YINC' && YINCRef.current) {
          setTypeError(false);
          return YINCRef.current.validate();
        } else if (props.regoType === 'ABN' && ABNRef.current) {
          setTypeError(false);
          return ABNRef.current.validate();
        } else if (props.regoType === 'ACN' && ACNRef.current) {
          setTypeError(false);
          return ACNRef.current.validate();
        } else if ((props.regoType === 'Other' || props.regoType === 'Other') && registrationRef.current) {
          setTypeError(false);
          return registrationRef.current.validate();
        }
      }
    };
  }

  const baseURL = typeof props.baseURL !== 'undefined' ? props.baseURL : REACT_APP_DEFAULT_BASE_URL;
  return (
    <>
      <OrganisationType
        regoType={props.regoType}
        setRegoType={(rt) => {
          props.setAbn('');
          props.setAcn('');
          props.setSelectedTradingName('');
          props.setBusinessName('');
          props.setRegoType(rt);
        }}
        disableABN={props.disableABN}
        disableACN={props.disableACN}
        disableYINC={props.disableYINC}
        disableOther={props.disableOther}
        typeError={typeError}
      />

      <div className={styles.marginTop1rem}>
        {props.regoType === 'ABN' ? (
          <OrganisationAbnAcn
            title="Registration Number"
            searchUrl={`${baseURL}${REACT_APP_GET_ABN_URL}`}
            type={'ABN'}
            value={props.abn}
            abn={props.abn}
            setAbn={setAbn}
            acn={props.acn}
            setAcn={setAcn}
            selectedTradingName={props.selectedTradingName}
            setSelectedTradingName={props.setSelectedTradingName}
            businessName={props.businessName}
            setBusinessName={props.setBusinessName}
            hideTradingNameList={props.hideTradingNameList}
            setAllBusinessNames={props.setAllBusinessNames}
            ref={ABNRef}
          />
        ) : null}

        {props.regoType === 'ACN' ? (
          <OrganisationAbnAcn
            title="Registration Number"
            searchUrl={`${baseURL}${REACT_APP_GET_ACN_URL}`}
            type={'ACN'}
            value={props.acn}
            abn={props.abn}
            setAbn={setAbn}
            acn={props.acn}
            setAcn={setAcn}
            selectedTradingName={props.selectedTradingName}
            setSelectedTradingName={props.setSelectedTradingName}
            businessName={props.businessName}
            setBusinessName={props.setBusinessName}
            hideTradingNameList={props.hideTradingNameList}
            setAllBusinessNames={props.setAllBusinessNames}
            ref={ACNRef}
          />
        ) : null}

        {props.regoType === 'YINC' ? (
          <OrganisationYINC
            YINCDetails={props.YINCDetails}
            setYINCDetails={props.setYINCDetails}
            YINCName={props.YINCName}
            setYINCName={props.setYINCName}
            YINCTradingName={props.YINCTradingName}
            setYINCTradingName={props.setYINCTradingName}
            ref={YINCRef}
          />
        ) : null}

        {props.regoType === 'Other' ? (
          <OrganisationOther
            registrationNumber={props.registrationNumber}
            setRegistrationNumber={props.setRegistrationNumber}
            orgName={props.orgName}
            setOrgName={props.setOrgName}
            tradingName={props.tradingName}
            setTradingName={props.setTradingName}
            ref={registrationRef}
          />
        ) : null}
      </div>
    </>
  );
};
export default forwardRef(OrganisationWrapped);
